
export const cardShader = {
  vertex: `
    uniform float uTime;
    uniform float uVelocity;
    uniform float uBend;
    varying vec2 vUv;
    varying float vDistortion;
    varying vec3 vNormal;

    void main() {
      vUv = uv;
      
      // SPHERICAL CORNER CURVE
      vec2 center = uv - 0.5;
      float distSq = dot(center, center);
      
      float strength = 3.0; 
      float zDisplacement = -distSq * strength;

      // Velocity wave
      float wave = sin(uv.y * 12.0 + uTime * 4.0) * 0.03 * uVelocity;
      
      vec3 newPosition = position;
      newPosition.z += zDisplacement + wave;

      // Latency stretch
      float stretch = sin(uv.y * 3.14159) * uVelocity * 0.6;
      newPosition.x += stretch;
      
      vNormal = normalize(vec3(center.x * strength, center.y * strength, 1.0));
      vDistortion = stretch;

      gl_Position = projectionMatrix * modelViewMatrix * vec4(newPosition, 1.0);
    }
  `,
  fragment: `
    uniform sampler2D uTexture;
    uniform sampler2D uUITexture;
    uniform float uOpacity;
    uniform float uHover;
    varying vec2 vUv;
    varying float vDistortion;
    varying vec3 vNormal;

    void main() {
      // Subtle Chromatic Aberration on the image
      float shift = vDistortion * 0.1 + (uHover * 0.015);
      
      vec4 baseColor;
      baseColor.r = texture2D(uTexture, vUv + vec2(shift, 0.0)).r;
      baseColor.g = texture2D(uTexture, vUv).g;
      baseColor.b = texture2D(uTexture, vUv - vec2(shift, 0.0)).b;
      baseColor.a = 1.0;

      // Mix with UI Overlay
      vec4 uiColor = texture2D(uUITexture, vUv);
      vec4 finalColor = mix(baseColor, vec4(1.0), uiColor.a * 0.9);
      finalColor.rgb += uiColor.rgb * uiColor.a;

      // Contrast / Saturation boost
      finalColor.rgb = mix(vec3(0.5), finalColor.rgb, 1.1);
      
      // Fresnel edge lighting
      float fresnel = pow(1.0 - abs(dot(vNormal, vec3(0, 0, 1))), 3.5);
      finalColor.rgb += fresnel * 0.5 * (1.0 + uHover * 2.0);

      // Glowing border
      float edgeX = abs(vUv.x - 0.5) * 2.0;
      float edgeY = abs(vUv.y - 0.5) * 2.0;
      float border = smoothstep(0.98, 1.0, max(edgeX, edgeY));
      vec3 glowColor = vec3(0.53, 0.53, 1.0); 
      finalColor.rgb += border * glowColor * (0.8 + uHover * 4.0);

      gl_FragColor = vec4(finalColor.rgb, uOpacity);
      if (gl_FragColor.a < 0.01) discard;
    }
  `
};
